// src/services/api.js
// Configuration centralisée de l'API

import axios from 'axios';

// URL du backend depuis .env
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.shynea.one/api';

console.log('🔗 API Backend URL:', API_BASE_URL); // Pour debug

// Instance Axios configurée
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token JWT (si besoin plus tard)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs globalement
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error('Erreur API:', error.response.status, error.response.data);
      
      // Déconnexion automatique si token expiré
      if (error.response.status === 401) {
        localStorage.removeItem('token');
      }
    } else if (error.request) {
      console.error('Pas de réponse du serveur');
    } else {
      console.error('Erreur:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;